import React, { Component } from "react";
import "./updatelang.css";
import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Spinner,
} from "reactstrap";
import axios from "axios";
import Swal from "sweetalert2";
import { configuration } from "../../../appConfig";
const toastAlert = Swal.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
});
export default class UpdateLang extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      value: [],
      langCode: [],
      numRows: 140,
      modal: false,
      isRequired: true,
      modalData: {},
      loading: false,
      tableData: {},
      words: {},
      labelName : [],
      lang: "",
    };
    this.handleChange = this.handleChange.bind(this);
    this.apiInputChange = this.apiInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  getLang = async () => {
    const base_url = window.location.origin;
    axios.get(`${base_url}/lang.json`).then((res) => {
      this.setState({
        words: res.data,
        lang: localStorage.getItem("lang"),
      });
    });
  };

  lang = (word) => {
    const { lang, words } = this.state;
    console.log(words[word]);
    console.log(lang);
    return words[word] ? words[word][lang] : word;
  };

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.lang !== prevState.lang) {
      return { lang: nextProps.lang };
    } else return null;
  }
  apiInputChange = (e, key, i) => {
    const { name, value } = e.target;
    const { tableData } = this.state;
    if (tableData[key]) {
      tableData[key] = {
        ...tableData[key],
        [name]: value,
      };
    } else {
      tableData[key] = {
        [name]: value,
      };
    }
    this.setState({
      tableData,
    });
  };

  handleChange = (e) => {
    const { name, value } = e.target;
    let { modalData } = this.state;
    modalData = {
      ...modalData,
      [name]: value,
    };
    this.setState({
      modalData,
    });
  };
  async handleSubmit(e, type) {
    e.preventDefault();
    const { modalData, tableData } = this.state;
    this.setState({ modal: false, loader: true });
    let url = configuration.addUpdateLanguage;
    let key =
      modalData &&
      modalData.label &&
      modalData.label.replaceAll(" ", "_").toLowerCase();

    let language_details;
    if (type === "table") {
      language_details = { ...tableData };
    } else {
      if (modalData.label === undefined) {
        toastAlert.fire({
          type: "error",
          title: "Please enter a language keyword",
        });
        this.setState({
          loader: false,
          modal: true,
        });
        return true;
      }
      language_details = { [key]: { ...modalData } };
    }

    await axios
      .post(url, { language_details })
      .then((res) => {
        toastAlert.fire({
          type: "success",
          title: res.data.message
            ? res.data.message
            : "Data saved successfully",
        });
        this.setState({
          loader: false,
          modalData: "",
          tableData: {},
        });
        this.handleGetLanguage();
      })
      .catch((err) => {
        toastAlert.fire({
          type: "error",
          title: "Something went wrong.Please try again later.",
        });
        this.setState({
          loader: false,
        });
      });
  }

  componentDidMount() {
    this.handleGetLanguage();
    this.getLang();
  }

  handleGetLanguage = async () => {
    const url = this.state.search
      ? `${configuration.getLanguageList}?search=${this.state.search}`
      : `${configuration.getLanguageList}`;
    this.setState({
      loading: true,
      data: [],
    });
    axios
      .get(url)
      .then((res) => {
        if (res && res.data && res.data.success) {
          const langObject = res.data.data.language_details;
          const labelNameCode = res.data.data.label_name;

          if (langObject && Object.keys(langObject).length > 0) {
            const firstKey = Object.keys(langObject)[0];
            const firstObject = firstKey && langObject[firstKey].translations;
            const translationsKeys = firstObject ? Object.keys(firstObject) : [];
            this.setState({
              data: langObject,
              labelName : labelNameCode,
              langCode: translationsKeys,
              loading: false,
            });
          } else {
            this.setState({
              data: {},
              langCode: [],
              labelName : [],
              loading: false,
            });
          }
        } else {
          this.setState({
            data: {},
            langCode: [],
            loading: false,
          });
        }
      })
      .catch((err) => {
        toastAlert.fire({
          type: "error",
          title: "Something went wrong. Please try again later.",
        });
        this.setState({
          loading: false,
        });
      });
  };
  

  toggle = () => {
    this.setState({ modal: !this.state.modal });
  };
  searchLang = (e) => {
    this.setState({
      search: e.target.value,
    });
    if (e.target.value === "") {
      this.setState(
        {
          search: "",
        },
        () => this.handleGetLanguage()
      );
    }
  };
  handleSearchKeyPress = (event) => {
    if (this.state.searchInOrder !== "" && event.key === "Enter") {
      this.setState(
        {
          isSearch: true,
        },
        () => this.handleGetLanguage()
      );
    }
  };
  render() {
    const { modal, loader, loading, search,labelName } = this.state;

    return (
      <>
        <div className="update-lang-wrapper">
          <div className="row justify-content-center">
            <div className="col-lg-12 col-md-12 col-sm-12 p-0">
              <div className="card p-0">
                <div className="card-header p-0">
                  <div className="row p-0 d-flex align-items-center justify-content-between">
                    <div className="col-lg-6 col-md-6 col-sm-12">
                      <div className="form-group">
                        <button
                          className="lang-btn btn"
                          onClick={() => this.toggle()}
                        >
                          <i className="fa fa-plus"></i>&nbsp; New Lang
                        </button>
                      </div>
                    </div>
                    <div className="col-lg-3 col-md-6 col-sm-12">
                      <div className="form-group lang-right-side">
                        <div className="position-relative">
                          <input
                            type="search"
                            placeholder={this.lang("Search")}
                            onChange={this.searchLang}
                            value={search}
                            name="search"
                            className="form-control"
                            onKeyDown={this.handleSearchKeyPress}
                          />
                          <button
                            className="lang-btn btn"
                            onClick={() => this.handleGetLanguage()}
                          >
                            <i className="fa fa-search"></i>&nbsp;
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card-body update-lang-table">
                  <div className="table-responsive">
                    <table className="table table-bordered table-striped">
                      <thead>
                        <tr>
                          <th className="text-center">
                            {this.lang("keyword")}
                          </th>
                          {!loading
                            ? this.state.langCode.map((key) => (
                                <th className="text-center">{key} <span>{labelName[key]}</span></th>
                              ))
                            : ""}
                        </tr>
                      </thead>
                      <tbody>
                        {loading && (
                          <tr>
                            <th
                              colSpan={this.state.langCode.length + 2}
                              className="text-center table-light"
                            >
                              {this.lang("Loading")}...
                            </th>
                          </tr>
                        )}
                        {Object.keys(this.state.data).length
                          ? Object.keys(this.state.data).map((key, i) => {
                              return (
                                <tr key={i}>
                                  {/* <td width={"10%"}>{(i + 1)}</td> */}
                                  <td>
                                    <input
                                      type="text"
                                      readOnly
                                      onChange={(e) =>
                                        this.apiInputChange(e, key, i)
                                      }
                                      defaultValue={this.state.data[key].label}
                                      title={this.state.data[key].label}
                                    />
                                  </td>
                                  {this.state.langCode.map((ikey) => (
                                    <td>
                                      <input
                                        type="text"
                                        name={ikey}
                                        onChange={(e) =>
                                          this.apiInputChange(e, key, i)
                                        }
                                        defaultValue={
                                          this.state.data[key].translations[
                                            ikey
                                          ]
                                        }
                                        title={
                                          this.state.data[key].translations[
                                            ikey
                                          ]
                                        }
                                      ></input>
                                    </td>
                                  ))}
                                </tr>
                              );
                            })
                          : !loading && (
                              <tr>
                                <th
                                  colSpan={this.state.langCode.length + 2}
                                  className="text-center table-light"
                                >
                                  {this.lang("No Data Found")}
                                </th>
                              </tr>
                            )}
                      </tbody>
                    </table>
                  </div>
                  <div className="bottom-update-lang-btn">
                    <button
                      className="lang-btn btn"
                      onClick={(e) => this.handleSubmit(e, "table")}
                      disabled={loader}
                    >
                      Update Lang
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Modal
          isOpen={modal}
          toggle={() => this.toggle()}
          size="xl"
          className="lang_modal"
        >
          <ModalHeader
          className="p-2"
            toggle={() => this.toggle()}>
            Add New Language
          </ModalHeader>
          <ModalBody>
            <div className="container-fluid p-0">
              <div className="row p-0">
                <div className="col-lg-12">
                  <div className="mb-3 form-group">
                    <label>Enter Keyword</label>
                    <input
                      className="form-control"
                      type="label"
                      placeholder="Enter Keyword"
                      required={this.state.isRequired}
                      onChange={(e) => this.handleChange(e)}
                      name="label"
                    />
                  </div>
                </div>
                <div className="col-lg-12 p-0">
                  <div className="row p-0">
                    {this.state.langCode.map((key) => (
                      <div className="col-lg-3 col-md-6 col-sm-6 col-sm-12">
                        <div className="mb-3 form-group">
                          <label>{key} <span>{labelName[key]}</span></label>
                          <input
                            className="form-control"
                            type="text"
                            name={key}
                            onChange={(e) => this.handleChange(e)}
                          />
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
            {/* <div className="card-body update-lang-table">
              <div className="table-responsive">
                <table className="table table-bordered table-striped">
                  <thead>
                    <tr>
                      <th className="text-center">{this.lang("keyword")}</th>
                      {this.state.langCode.map((key) => (
                        <th className="text-center">{key}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        <input
                          type="label"
                          required={this.state.isRequired}
                          onChange={(e) => this.handleChange(e)}
                          name="label"
                        />
                      </td>
                      {this.state.langCode.map((key) => (
                        <td>
                          <input
                            type="text"
                            name={key}
                            onChange={(e) => this.handleChange(e)}
                          />
                        </td>
                      ))}
                    </tr>
                  </tbody>
                </table>
              </div>
            </div> */}
          </ModalBody>
          <div className="bottom-update-lang-btn">
            <ModalFooter>
              <Button className="cancel-btn btn" onClick={() => this.toggle()}>
                Cancel
              </Button>
              <Button
                variant="contained"
                type="button"
                className="lang-btn btn"
                onClick={this.handleSubmit}
                disabled={loader}
              >
                {loader ? <Spinner color="light" size="sm" /> : "Submit"}
              </Button>
            </ModalFooter>
          </div>
        </Modal>
      </>
    );
  }
}
